import { Vault } from '@/features/vaults/types';

export const monadVault: Vault = {
  id: 'monad-vault',
  type: 'core-vault',
  name: 'Monad Vault',
  description:
    'The Monad Vault provides diversified exposure to the ecosystem&apos;s core collateral, money markets, and stable liquidity venues to support ecosystem expansion through incentives and conservative risk management.',
  category: 'core-vault',
  address: '0x912644cdFadA93469b8aB5b4351bDCFf61691613',
  curators: [],
  operator: [],
  // Cannot show Mellow points (legal)
  points: [],
  network: 'monad',
  networks: [
    {
      network: 'monad',
      vaultAddress: '0x912644cdFadA93469b8aB5b4351bDCFf61691613',
    },
  ],
  baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  lpTokenSymbol: 'MVT',
  lpTokenDecimals: 18,
  oracleUpdateInterval: BigInt(7 * 86400),
  redeemHandlingInterval: BigInt(3600),
  deposit: {
    disabled: true,
  },
  callConfigOrigin: {
    branch: 'deploy/monad',
    filenamePrefix: 'monad:mon',
  },
  allocations: {
    showAllocationsTab: false,
  },
  archived: true,
};
